'use strict';

var React = require('react');
var Link = require('react-router').Link;
var RouteConstants = require('../constants/RouteConstants');
var OmnitureTracking = require('../utils/OmnitureTracking');

class NotFound extends React.Component {
    componentDidMount() {
        OmnitureTracking.getTrackingEnabled(true);
    }

    render() {
        return (
			<div className="not-found">
                <h1>Page Not Found</h1>
				<p><Link to={RouteConstants.Root}>Back to Home</Link></p>
            </div>
		);
    }
}
module.exports = NotFound;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/NotFound.jsx